var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{attrs:{"allow-empty":false,"options":_vm.options,"value":_vm.selected,"clearable":false,"input-id":"freq","label":"label"},on:{"input":_vm.select}})
}
var staticRenderFns = []

export { render, staticRenderFns }